import { IsInt, IsOptional, Min } from 'class-validator';
import { ApiPropertyOptional } from '@nestjs/swagger';

export class SubmitAttemptRequestDto {
  /**
   * Durée active cumulée (secondes) - temps passé sur l'activité hors pauses (onglet caché).
   * Côté backend : plafonné à (now - startedAt) pour anti-triche.
   */
  @ApiPropertyOptional({
    description:
      'Durée active cumulée en secondes (temps visible). Plafonnée côté serveur.',
  })
  @IsOptional()
  @IsInt()
  @Min(0)
  accumulatedDurationSec?: number;
}
